import { FC } from 'react'
import { Tag, TagType } from './Tag'
import { Option, OptionType } from './Option'

export const Role: FC & TagType & OptionType = (): JSX.Element => <></>

Role.Tag = Tag
Role.Option = Option
